<template>
  <el-dialog
    :title="detailTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="ruleForm"
    >
      <el-form-item label="标题：">
        <el-input v-model="ruleForm.articleTitle" disabled></el-input>
      </el-form-item>
      <el-form-item label="文章分类：">
        <el-input v-model="ruleForm.articleTypeName" disabled></el-input>
      </el-form-item>
      <el-form-item label="文章概要：">
        <el-input
          type="textarea"
          v-model="ruleForm.summary"
          :rows="3"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="关键字：">
        <el-input v-model="ruleForm.keyWord" disabled></el-input>
      </el-form-item>
      <el-form-item label="正文：">
        <el-input
          type="textarea"
          v-model="ruleForm.articleContent"
          :rows="10"
          disabled
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <butn
        btntype="primary"
        title="关闭"
        @click.native="CUFlag = false"
      ></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { articleDetail } from "@/api/article";

export default {
  components: { butn },
  data() {
    return {
      Bus,
      size: "small",
      ruleForm: {},
      detailTitle: "原创文章详情",
      CUFlag: false
    };
  },
  methods: {
    info(uuid) {
      articleDetail(uuid).then(res => {
        if (res && res.code == 0) {
          this.ruleForm = res.data;
        }
      });
    }
  },
  created() {
    let _this = this;
    Bus.$on("details", function(item) {
      _this.CUFlag = true;
      _this.info(item.uuid);
    });
  }
};
</script>
